import * as Preact from 'preact';
import Box from '@mui/material/Box';
import * as ProgressWithLabel from './M_ProgressWithLabel';
import { SxProps } from '@mui/system';

export interface Props {
    children?: Preact.ComponentChildren;
    statusText?: string;
    sx?: SxProps;
}

/** A ProgressWithLabel Grouped with some other element */
export const Component: Preact.FunctionComponent<Props> = (p: Props) => (
    <Box
        sx={{
            paddingX: { xs: '16px', md: '26px' },
            paddingTop: '26px',
            paddingBottom: { xs: '26px', md: '69px' },
            ...p.sx,
        }}
    >
        {p.children}
        <ProgressWithLabel.Component statusText={p.statusText ?? 'Please wait'} />
    </Box>
);
Component.displayName = 'ProgressGroup';
